import { css } from "@emotion/react";

import Menu, {
    centeredAnchorOrigin,
    centeredTransformOrigin
} from "../../DesignComponents/Menu";
import FindToolContent from "./components/FindToolContent";
import { FindToolDesktopProps } from "./types";

const FindToolDesktop = ({ anchorEl, close }: FindToolDesktopProps) => {
    return (
        <Menu
            open={Boolean(anchorEl)}
            onClose={close}
            anchorEl={anchorEl}
            anchorOrigin={centeredAnchorOrigin}
            transformOrigin={centeredTransformOrigin}
            slotProps={{
                list: {
                    disableListWrap: true
                }
            }}
            css={css({
                "& .MuiMenu-paper": {
                    width: "564px"
                }
            })}
        >
            <li>
                <FindToolContent close={close} />
            </li>
        </Menu>
    );
};

export default FindToolDesktop;
